const state = () => ({
})

const actions = {
  fetchByDepartmentCode({ }, { departmentCode }) {
    return axios
      .get(`/departments/by-code/${departmentCode}`)
      .then((response) => {
        return response.data
      })
  },
}

const mutations = {

}

const getters = {
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
